// Importação do utilitário que desabilita console.log em produção - deve ser o primeiro import
import './utils/disableConsole';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { OnboardingStatusProvider } from './pages/OnboardingPage';
import App from './App.tsx';
import './index.css';
import ErrorBoundary from './components/ErrorBoundary';
import ErrorPage from './pages/ErrorPage';

// Log apenas em ambiente de desenvolvimento
if (!import.meta.env.PROD) {
  console.log(`Ambiente: ${import.meta.env.MODE}, Produção: ${import.meta.env.PROD ? 'Sim' : 'Não'}`);
}

// Determina o basename com base no ambiente de execução
const getBasename = () => {
  // Se estiver em produção, use o pathname da URL até o último '/'
  // Isso ajuda em hosts como a Vercel que podem usar subpaths
  if (import.meta.env.PROD) {
    const pathSegments = window.location.pathname.split('/');
    
    // Remove o último segmento vazio (se existir) ou o último segmento de rota
    pathSegments.pop();
    
    // Se o resultado for vazio, use '/'
    return pathSegments.join('/') || '/';
  }
  
  // Em desenvolvimento, use '/'
  return '/';
};

// Inicializando a aplicação
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter basename="/">
        <AuthProvider>
          <ErrorBoundary fallback={<ErrorPage standalone={true} />}>
            <OnboardingStatusProvider>
              <App />
              <Analytics />
              <SpeedInsights />
            </OnboardingStatusProvider>
          </ErrorBoundary>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
);